export const EVENTS = {
  PHONE: {
    RESOLVE: 'PHONE.RESOLVE',
    RESOLVING: 'PHONE.RESOLVING',
    RESOLVED: 'PHONE.RESOLVED',
    RESOLVE_ERROR: 'PHONE.RESOLVE_ERROR'
  }
};

export const ENDPOINTS = {
  PHONE: {
    RESOLVE:
      'https://api.kingrecharges.com/carrier-mapper/resolve/{phone}?group=payment'
  }
};
